const sourceToolTypeEnum = {
    Admin:     1,
    Teacher:   2,
    Student:   3,
    Connector: 4,
    Manager:   5,
};

export default sourceToolTypeEnum;
